module.exports = __webpack_public_path__ + "static/img-17-d5a522538cc06e97cd0fb2fe5e9714b6.jpeg";